module.exports = __webpack_public_path__ + "img/me_jiaoyiquxiao_icon@2x.e68235b1.png";